export const CUSTOM_COLOUR_KEY = 'mindmappi.lastCustomColour';
export const isHexColour = value => /^#[0-9a-f]{6}$/i.test(value);
export function readCustomColour() {
  try {
    const value = localStorage.getItem(CUSTOM_COLOUR_KEY);
    return isHexColour(value) ? value : null;
  } catch { return null; }
}
export function hexToHsl(hex) {
  const [r, g, b] = hex.slice(1).match(/../g).map(value => parseInt(value, 16) / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b), delta = max - min;
  const lightness = (max + min) / 2;
  let hue = 0;
  if (delta) {
    if (max === r) hue = ((g - b) / delta) % 6;
    else if (max === g) hue = (b - r) / delta + 2;
    else hue = (r - g) / delta + 4;
  }
  return [(hue * 60 + 360) % 360, delta ? delta / (1 - Math.abs(2 * lightness - 1)) * 100 : 0, lightness * 100];
}
export function hslToHex([hue, saturation, lightness]) {
  const s = saturation / 100, l = lightness / 100;
  const a = s * Math.min(l, 1 - l);
  const channel = n => {
    const k = (n + hue / 30) % 12;
    return Math.round(255 * (l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1)))).toString(16).padStart(2, '0');
  };
  return `#${channel(0)}${channel(8)}${channel(4)}`;
}
